/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';
import { BILLING_FIELDS } from '../../fragments';
import { CreateBillingProps } from './billing.types';
import { BillingType } from '../../../types';
import { GET_BILLING_BY_REFERENCE_ID } from '../../queries';

export const CREATE_BILLING = gql`
  ${BILLING_FIELDS}
  mutation createBilling(
  $referenceId: ID!,
  $account: String,
  $swift: String,
  $name: String,
  $email: String,
  $phone1: String,
  $phone2: String,
  $addressLine1: String,
  $addressLine2: String,
  $city: String,
  $province: String,
  $country: String,
  ) {
    createBilling(
    referenceId: $referenceId,
    account: $account,
    swift: $swift,
    name: $name,
    email: $email,
    phone1: $phone1,
    phone2: $phone2,
    addressLine1: $addressLine1,
    addressLine2: $addressLine2,
    city: $city,
    province: $province,
    country: $country,
    )
    {
      ...BillingFields
    }
  }
`;

export function createBilling({
  client,
  referenceId,
  account,
  swift,
  name,
  email,
  phone1,
  phone2,
  addressLine1,
  addressLine2,
  city,
  province,
  country,
}: CreateBillingProps) {
  return client?.mutate<{ createBilling: BillingType }>({
    mutation: CREATE_BILLING,
    variables: {
      referenceId,
      account,
      swift,
      name,
      email,
      phone1,
      phone2,
      addressLine1,
      addressLine2,
      city,
      province,
      country,
    },
    refetchQueries: [
      GET_BILLING_BY_REFERENCE_ID,
    ],
  });
}
